import React, { useEffect } from 'react';
import '../MiZona/MiZona.css';
import { formatearFecha } from '../MiZona/estadosPartido';
import PartidoVs from './PartidoVs';
import { AVISO_REVISION_COMITE } from './aplazamientoUtils';

// Resumen previo al envío. «Revisar» solo cierra la modal: el formulario sigue
// abierto y relleno. Tras enviar, la misma modal muestra el éxito.
export default function ModalResumen({ partido, admiteWo, conJustificante, fechaLimite, enviando, error, exito, sinCorreo, onRevisar, onSolicitar, onCerrar }) {
  useEffect(() => {
    const alPulsar = (e) => { if (e.key === 'Escape' && !enviando) (exito ? onCerrar : onRevisar)(); };
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, [enviando, exito, onRevisar, onCerrar]);

  return (
    <div className="mz-modal-fondo">
      <div className="mz-modal" role="dialog" aria-modal="true" aria-labelledby="ap-modal-titulo">
        {exito ? (
          <>
            <h3 id="ap-modal-titulo">Aplazamiento del partido solicitado con éxito</h3>
            {conJustificante && <p role="status">{AVISO_REVISION_COMITE} Hasta entonces tu partido sigue pendiente.</p>}
            {sinCorreo && (
              <p className="ap-banner" role="status">
                Tu solicitud está registrada, pero no hemos podido avisar al comité por correo. Escríbenos tú a fmds.bad@gmail.com.
              </p>
            )}
            <div className="mz-modal-acciones">
              <button type="button" className="btn btn-primary" onClick={onCerrar}>Cerrar</button>
            </div>
          </>
        ) : (
          <>
            <h3 id="ap-modal-titulo">Resumen de la solicitud</h3>
            <p><strong>Jornada:</strong> {partido.jornada} ({formatearFecha(partido.fechaJornada)})</p>
            <p><strong>Modalidad:</strong> {partido.modalidad}</p>
            <p><strong>Partido a aplazar:</strong> <PartidoVs partido={partido} /></p>

            <p className="ap-banner" role="note">
              {conJustificante && <><strong>{AVISO_REVISION_COMITE}</strong>{' '}</>}
              {admiteWo
                ? 'Admites WO: se te puntuará como incomparecencia según el reglamento de bádminton (0 puntos si avisas con al menos 7 días de antelación, -1 si avisas con menos) y tu partido no se aplazará.'
                : `Tienes hasta ${formatearFecha(fechaLimite)} para recuperar el partido. Pasado este tiempo se considerará incomparecencia según reglamento de bádminton.`}
            </p>
            <p>Revisa que está todo correcto antes de solicitarlo. Una vez solicitado, ya no será posible dar marcha atrás.</p>

            {error && <p className="msg-error" role="alert">{error}</p>}
            <div className="mz-modal-acciones">
              <button type="button" className="btn btn-danger" disabled={enviando} onClick={onRevisar}>Revisar</button>
              <button type="button" className="btn btn-success" disabled={enviando} onClick={onSolicitar}>
                {enviando ? 'Solicitando…' : 'Solicitar'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
